/**
 * Wraps the parenthesized portion of the text inside Judge.me's
 * `.jdgm-prev-badge__text` element with a <span>, starting at "(" and ending
 * at ")". Extra whitespace inside the parentheses is collapsed, so
 * "( 11 reviews )" becomes "(11 reviews)" before being wrapped.
 *
 * The existing CSS rule `.jdgm-prev-badge__text span { ... }` then styles
 * just the parenthesized segment. The "No reviews" fallback (no parens) is
 * left untouched.
 *
 * Uses a MutationObserver so it works with badges injected after initial
 * page load (Judge.me's widget loads asynchronously, and badges can also be
 * re-rendered when AJAX-loaded products appear).
 */
(function () {
  'use strict';

  var SELECTOR = '.jdgm-prev-badge__text';
  var PAREN_RE = /\(\s*([^()]*?)\s*\)/;

  function findParenSpan(el) {
    var spans = el.getElementsByTagName('span');
    for (var i = 0; i < spans.length; i++) {
      var text = spans[i].textContent;
      if (text.charAt(0) === '(' && text.charAt(text.length - 1) === ')') {
        return spans[i];
      }
    }
    return null;
  }

  function wrap(el) {
    if (!el) return;

    var text = el.textContent;
    var match = text && text.match(PAREN_RE);
    if (!match) return;

    var normalized = '(' + match[1] + ')';
    var existing = findParenSpan(el);

    if (existing && existing.textContent === normalized) return;

    var before = text.slice(0, match.index);
    var after = text.slice(match.index + match[0].length);

    el.textContent = '';
    if (before) el.appendChild(document.createTextNode(before));
    var span = document.createElement('span');
    span.textContent = normalized;
    el.appendChild(span);
    if (after) el.appendChild(document.createTextNode(after));
  }

  function processAll(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches(SELECTOR)) {
      wrap(root);
    }
    if (root.querySelectorAll) {
      var els = root.querySelectorAll(SELECTOR);
      for (var i = 0; i < els.length; i++) wrap(els[i]);
    }
  }

  function init() {
    processAll(document);

    if (typeof MutationObserver === 'undefined' || !document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === 1) processAll(node);
        }

        var target = m.target;
        if (
          target &&
          target.nodeType === 1 &&
          target.classList &&
          target.classList.contains('jdgm-prev-badge__text')
        ) {
          wrap(target);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
